export default __webpack_public_path__ + "static/benifit-0e8aae3f4bbd55e222b2d94f13070e77.png";